export default __webpack_public_path__ + "assets/images/c34ddd4072819de9e34fbbb8f3b1bedd.png";